import React, { memo } from "react";
import { HStack, Spacer } from "@chakra-ui/react";
import ComposeBottomToolbarCalloutButton from "./compose-bottom-toolbar-callout-button";
import ComposeBottomToolbarTagButton from "./compose-bottom-toolbar-tag-button";
import ComposeBottomToolbarExternalUserButton from "./compose-bottom-toolbar-external-user-button";
import { QuillMention } from "modules/quill/mentions/use-quill-mentions";
import ComposeBottomToolbarFileButton from "./compose-bottom-toolbar-file-button";
import ComposeBottomToolbarGifButton from "./compose-bottom-toolbar-gif-button";
import ComposeBottomToolbarEmojiButton from "./compose-bottom-toolbar-emoji-button";
import ComposeBottomToolbarSendThreadButton from "./compose-bottom-toolbar-send-thread-button";
import ComposeBottomToolbarSendChatButton from "./compose-bottom-toolbar-send-chat-button";
import ComposeBottomToolbarSendTaskButton from "./compose-bottom-toolbar-send-task-button";
import ComposeBottomToolbarCreateTaskButton from "./compose-bottom-toolbar-create-task-button";
import { MessageThreadFragment } from "gql/graphql";

interface IProps {
  draftId: string;
  appendText: (value: string) => void;
  appendMention: (mention: QuillMention) => void;
  onSend: () => void;
  isSending?: boolean;
  messageThread?: MessageThreadFragment; // for replies
}

const ComposeBottomToolbar = ({
  draftId,
  appendText,
  appendMention,
  onSend,
  isSending,
  messageThread,
}: IProps) => (
  <HStack spacing={6} minH={8}>
    <ComposeBottomToolbarTagButton draftId={draftId} appendText={appendText} />
    <ComposeBottomToolbarCalloutButton
      appendText={appendText}
      draftId={draftId}
      messageThread={messageThread}
    />
    <ComposeBottomToolbarExternalUserButton
      appendMention={appendMention}
      draftId={draftId}
      messageThread={messageThread}
    />
    <ComposeBottomToolbarFileButton draftId={draftId} />
    <ComposeBottomToolbarGifButton draftId={draftId} />
    <ComposeBottomToolbarEmojiButton
      appendText={appendText}
      draftId={draftId}
    />
    <Spacer />
    <ComposeBottomToolbarSendThreadButton
      draftId={draftId}
      onSend={onSend}
      isSending={isSending}
    />
    <ComposeBottomToolbarSendChatButton
      draftId={draftId}
      onSend={onSend}
      isSending={isSending}
    />
    <ComposeBottomToolbarSendTaskButton
      draftId={draftId}
      onSend={onSend}
      isSending={isSending}
    />
    <ComposeBottomToolbarCreateTaskButton
      draftId={draftId}
      onSend={onSend}
      isSending={isSending}
    />
  </HStack>
);

export default memo(ComposeBottomToolbar);
